import React, { Component } from 'react';
import { Button, Card, CardTitle, CardActions } from 'react-md';

class RoomsItem extends Component {

    getButtons(indices) {
        
        return indices.map(index => {

            let seat = this.props.room[`seat${index}`];
            let seatIsOccupied = seat !== undefined;
            var label = seatIsOccupied ? seat : 'Join';

            let truncatePast = 12;
            let cleanLabel = label
                    .substring(0, truncatePast)
                    .concat(label.length > truncatePast ? '...' : '');
            cleanLabel = "".concat(cleanLabel);

            return <Button 
                key={index} 
                flat 
                secondary 
                disabled={seatIsOccupied}
                onClick={() => { this.props.clickHandler(this.props.room.id, index, this.props.displayName) }}>
                    {cleanLabel}
                </Button>;
         });
    }

    render() {
        
        const cardStyle = {
            maxWidth: 370,
            wordBreak: 'break-word'
        };

        const isFull = this.props.room.count === 4;
        const partialTitle = this.props.room.name ? this.props.room.name : this.props.room.id;
        const fullTitle = `${partialTitle}`.concat(isFull ? ' (Full)' : '');

        return (
            <Card style={cardStyle} className="md-block-centered roomInfoCard" >
                <CardTitle 
                    title={fullTitle} 
                    subtitle={this.props.message}
                    
                />
                <CardActions>
                    {this.getButtons([0])}
                </CardActions>
                <CardActions >
                    {this.getButtons([1, 3])}
                </CardActions>
                <CardActions>
                    {this.getButtons([2])}
                </CardActions>
            </Card>
        );
    }
}

export default RoomsItem;


// WEBPACK FOOTER //
// ./src/RoomsItem.jsx